import React from 'react';

import nuuvemImg from "./img/nuuvem.svg";

import treeImg from "./img/tree.svg";
import jumpImg from "./img/jump.svg";
import expressoImg from "./img/expresso.svg";
import ngtImg from "./img/ngt.svg";

import spectraImg from "./img/spectra-logo.svg"

import "./app.css";

function App() {
  return (
    <div className="App">
      <div className="main-header">
        <img src={nuuvemImg} className="logo-header" />
      </div>
      <span className='main-title'>Escolha o provedor</span>
      <div className="links-grid">
          <div className="link-item">
            <img src={treeImg} alt="tree" />
            <a href="https://treenetwork.contratoonline.tec.br?back=vendas.nuuvemtelecom.com.br">Acessar contrato online</a>
          </div>
          <div className="link-item">
            <img src={jumpImg} alt="jump" />
            <a href="https://jumpnetwork.contratoonline.tec.br?back=vendas.nuuvemtelecom.com.br">Acessar contrato online</a>
          </div>
          <div className="link-item">
            <img src={expressoImg} alt="expresso" />
            <a href="https://exxpressotelecom.contratoonline.tec.br?back=vendas.nuuvemtelecom.com.br">Acessar contrato online</a>
          </div>
          <div className="link-item">
            <img src={ngtImg} alt="ngt" />
            <a href="https://ngt-telecom.contratoonline.tec.br?back=vendas.nuuvemtelecom.com.br">Acessar contrato online</a>
          </div>
      </div>

      <div className="logo-spectra">
        <span>Desenvolvido por:</span>
        <a href="http://spectra.tec.br" target="_blank" rel="noopener noreferrer">
          <img src={spectraImg} alt="" />
        </a>
      </div>
    </div>
  );
}

export default App;
